export default __webpack_public_path__ + "static/media/DarkAnular.0a197e69.svg";